import { render, staticRenderFns } from "./RziFitoLayers.vue?vue&type=template&id=2886ad0f&scoped=true&"
import script from "./RziFitoLayers.vue?vue&type=script&lang=js&"
export * from "./RziFitoLayers.vue?vue&type=script&lang=js&"
import style0 from "./RziFitoLayers.vue?vue&type=style&index=0&id=2886ad0f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2886ad0f",
  null
  
)

export default component.exports